export default __webpack_public_path__ + "static/media/w2.1a2bcf2a.jpg";